/*eslint-disable*/
import easydropdown from 'easydropdown'

export default form => {
	$(document).ready(() => {
		let $form = $(form)

    $form.find('.country-dropdown, .state-dropdown').change(e => $(e.target).css('color', 'black'))

		const selectMenues = form.querySelectorAll('select')
		selectMenues.forEach((sel, idx)=>{
			if (sel) {
				let edd = easydropdown(sel, {
					behavior: {
						useNativeUiOnMobile: false,
						showPlaceholderWhenOpen: true,
						liveUpdates: true,
					},
					classNames: {
						rootOpenBelow: true,
						rootOpenBelow: 'edd-root-open-below'
					},
					callbacks: {
						onOpen: value => {
							$('.edd-root').removeClass('edd-root-open-above').addClass('edd-root-open-below')
						},
					}
				})
			}
		})
	})
}


// WEBPACK FOOTER //
// ./src/scripts/components/account-address-form.js